/* eslint-disable no-unused-vars */
/* eslint-disable default-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useRef, useState } from 'react';
import { APIEndpoint, DFPAPIEndpoint } from "../../../utils/axios";
import { DataGrid, AddProductModal, UploadModal, DeleteConf } from "../../../common";
import { onDownloadXlsFile,formatDateByTimezone } from '../../../utils/commonFunctions';
import { MIMETypes } from '../../../utils/configs';
import moment from "moment";
import { useTranslation } from 'react-i18next';
import Edit2 from "../../../assets/edit2.svg";
import usePermissions from '../../../utils/userPermissions';
import CustomSelect from "../../../common/CustomSelect";
import  LoadingGIF from '../../../assets/loadingIn.gif'
import uploadItemIcon from '../../../assets/icons/upload-items.svg';
import downloadMasterIcon from '../../../assets/icons/download-master.svg';
import HeaderSelectAll from '../../../common/HeaderSelectAll';


export const ManageProductsPage = (props) => {
  const priceListOptions = useRef(null);
  const Fields = useRef([]);
  const { t,ready } = useTranslation();
  const [state, setState] = useState({ isListReady: false, filterPrice: '', filterPriceValue:[],resetDataSource: false, })
  const [isDownloading, setIsDownloading] = useState(false);
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const [ uploadedFile, setUploadedFile ] = useState([])
  const [checkbox,setCheckBox]=useState(false)
  const [buttonStat,setButtonStat]=useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [fromDetails,setFormDetails]=useState([]);
  const [buttonData, setButtonData] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectAll,setSelectAll]= useState({isChecked:false,label:'Item Code'});
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const sType = localStorage.getItem('sType');
  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);
  const timeOut=useRef(null);

  const { hasPermission: editpriceMaster } = usePermissions('edit', "orn:Store:ManagePriceList");
  const { hasPermission: downloadpriceMaster } = usePermissions('download',"orn:Store:ManagePriceList");
  const { hasPermission: uploadpriceMaster } = usePermissions('upload',"orn:Store:ManagePriceList");

  React.useEffect(() => {
    fetchPriceList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    React.useEffect(() => {
      return ()=>{
        if(timeOut?.current){
        clearTimeout(timeOut.current)
        }
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    React.useEffect(() => {
     state.filterPrice? setCheckBox(true): setCheckBox(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.filterPrice]);

  const CustomHeader = (props) => {
    return (
      <div className='flexCol'>
        <div className='ag-header-cell-text'>{props.displayName}</div>
      {!state.filterPrice
      ?  <div className='ag-header-cell-text'>(select a price list)</div>:<></>}
      </div>
    );
  };

  const HeaderCheckBoxRenderer=()=>{
    return (
      <HeaderSelectAll
      checkbox={checkbox}
      selectAll={selectAll}
      setSelectAll={setSelectAll}/>
  );

  }

  function setToutFileUpload(){
  timeOut.current = setTimeout(() => {
        setState( (_prev) => {
        return { ..._prev,resetDataSource:!_prev.resetDataSource}
      });
        onUploadClose()
    }, 2500);
}
  const Columns = [
    { field: 'itemCode', headerName: 'Item Code',cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    }, tooltipField: 'itemCode',suppressSizeToFit:true,resizable:true,checkboxSelection: checkbox ,headerComponentFramework : HeaderCheckBoxRenderer, minWidth: 230,width:250 },
    { field: 'itemName', headerName: 'Item Name',  flex:1,suppressSizeToFit:true, resizable:true,minWidth: 230 ,width: 255 , tooltipField: 'itemName',cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    }, },
    { field: 'category', headerName: 'Category',cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    },   flex:1,suppressSizeToFit:true,resizable:true,minWidth: 155 },
    { field: 'subCategory', headerName: 'Sub Category',cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    },  flex:1,suppressSizeToFit:true,resizable:true, minWidth: 155 },
    { field: 'itemPrice', headerName: 'Price', headerComponent:CustomHeader,valueGetter: (params) => {
      return params?.data?.itemPrice != null
        ? parseFloat(params?.data?.itemPrice).toFixed(2)
        : !params?.data?.itemPrice ? null:"NA";
    },  flex:1,suppressSizeToFit:true, resizable:true,minWidth: 125},
  ];


  const fetchProducts = useCallback(async (iPageNo = 1, iPageLimit = 50, iSearchText = '') => {
   const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    page:iPageNo,
    limit:iPageLimit,
    searchParam:iSearchText
  }
    if(!state.filterPrice){
      setButtonData(null)
    } else{
      setIsDownloading(false)
      setButtonData(
        {deleteButton:{
             title: t('pages.productsContent.manageProducts.remove'),
            className:'m-2 flex justifyContentCenter alignItemsCenter',
             onClick: handleDeleteAction,
           },
           addButton:{
            title:`+ ${t('pages.productsContent.manageProducts.addItem')}`,
            className:'m-2',
             onClick: handleAddSector
           }
         })
    }
    if (state.filterPrice) {
      filterData.filters = [{ listName: state.filterPrice }]
    }
    const res = await DOMAIN.post('items/process', filterData);
    setProducts(res)
    return res;
  },[state?.filterPrice])

  const fetchPriceList = async () => {

    try {
       const priceList = await DOMAIN.get('items/price-list');
    if (priceList.result.length) {
      priceListOptions.current = priceList.result?.map((_pl,index) => {
        return {key:index, value: _pl, label: _pl }
      })
    } else {
      priceListOptions.current = [];
    }
    } catch (error) {
      console.error('Error fetching price list:', error);
    }finally{
       setState((_) => {
        return { ..._, isListReady: true }
      })
    }

  };

  const handleModalClose = (e, iReset=null) => {
    if(!e && !iReset){
      setState((currentState) => {
        return { ...currentState, showAddForm: false, editRow: null,detailsRow: null }
      })
    }

   else if (!e && iReset) {
      let timeoutId = setTimeout(() => {
       setModalFormStatusObj({text:""})
       setButtonStat(false);
        clearTimeout(timeoutId)
        setState((_) => {
          return { ..._, detailsRow: null, deleteRows: null, resetDataSource: iReset ? !state.resetDataSource : state.resetDataSource }
        });
      }, 1500)
    }else{
      setState((_) => {
        return { ..._, showAddForm: false, editRow: null,detailsRow: null, deleteRows: null, resetDataSource: iReset ? !state.resetDataSource : state.resetDataSource }
      });
    }
    if(selectAll.isChecked){
      setSelectAll((_)=>({..._,isChecked:!_.isChecked}));
    }
  }

  const handleAddSector = () => {
    setState((_) => {
      return { ..._, showAddForm: true }
    })
  }

  const onUploadFileChangeHandler = async (e) => {
    const file=e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');

    const formData = new FormData();
    formData.append('scheduleLater', false);
    formData.append('listName',fromDetails[0]?.name|| undefined);
    formData.append('targetSectorType',fromDetails[0]?.type|| undefined);
    formData.append('effectiveDate',fromDetails[0]?.date?moment(fromDetails[0]?.date, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ").format():"" || undefined);
    formData.append('stores',JSON.stringify(fromDetails[0]?.stores || [undefined]));
    formData.append('warehouses', JSON.stringify(fromDetails[0]?.warehouses || [undefined]));
    formData.append('file', file);

    try {
      await DOMAIN.post('excel/upload/items', formData);
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
      setToutFileUpload();
    }
    catch(error) {
      console.log("ERROR data raw:",error)

      e.target.value = null;
      setUploadedFile([]);
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;

      let msgContent = "";
      if (status === 400 && data && data.errors) {
          data.errors.forEach( _ => {
            const lineNum = _.lineNumber;
            const errorMsgArr = [];
            _.errors.forEach(erObj => {
              errorMsgArr.push( erObj.field + ' | ' + erObj.message + ' \n<br>' );
            });

            msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
        });
      }
      else if(status === 400 && data && data?.Error){
       msgHeading = data.Error;
       msgContent += 'Error occured while upload price List sheet!';
      }
      else {
        msgContent += 'Error occured while upload price List sheet!';
      }

      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                 "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }
};


  const handleAddSectorSubmit = async (e, values) => {
    try {
        if (values) {

      const res = await DOMAIN.post('item', values);
      if (res.success) {
        setModalFormStatusObj({ text:res.msg||'Item added to Price List'})

        handleSelectPriceList({ target: { value: state.filterPrice } })
      }

    }
    } catch (error) {
      let {data}=JSON.parse(error.message)
        setModalFormStatusObj({ error:data.msg})

      }
    let timeoutId = setTimeout(() => {
        clearTimeout(timeoutId)
        setModalFormStatusObj({text:""})
      }, 3500)

    }

  const handleEditSectorSubmit = async (e, values) => {
    if (values != null) {
      try {
        const res = await DOMAIN.put('item/' + values.itemId, values);
      if (res.success) {
        setModalFormStatusObj({ text:res.msg || "Item updated successfully"})
        setTimeout(() => {
          handleSelectPriceList(state.filterPriceValue[0])
        }, 2000);
      }
      } catch (error) {
        let {data}=JSON.parse(error.message)
        setModalFormStatusObj({ error:data.msg})

      }
    let timeoutId = setTimeout(() => {
        clearTimeout(timeoutId)
        setModalFormStatusObj({text:""})
      }, 3500)

    }
  }

  const handleSelectPriceList = (e) => {
    setState((_) => {
      return { ..._, filterPrice:e?e.value:null,filterPriceValue:[e],resetDataSource:!state.resetDataSource, showAddForm: false, editRow: null }
    });
    let timeoutId = setTimeout(() => {
      clearTimeout(timeoutId)
      setModalFormStatusObj({text:""})
      setState((_) => {
        return { ..._,resetDataSource:!state.resetDataSource}
      });
    }, 100)
  }

  const handleRowAction = async (e, action, row) => {
    setState((_prev) => {
      return { ..._prev, editRow: row }
    })
  }

  const handleDeleteAction = (e, selected) => {
    setState((currentState) => {
      return { ...currentState, deleteRows: selected }
    })
  }

  const handleDeleteConfirm = async () => {
    const items = state.deleteRows.map((_) => _.itemId);
    try {
      setButtonStat(true);
      const res = await DOMAIN.put('items/remove?pl='+state.filterPrice, { ids: items });
      if(res.success){
        setModalFormStatusObj({text:res.message||'Item deleted successfully'})
      }
    } catch (error) {
      const dataErr=JSON.parse(error.message)
      setModalFormStatusObj({error:dataErr.data.message||'Failed!'})
    }
    handleModalClose(null, true);

  }



  const onDownloadPriceList=async()=>{
    if(isDownloading) return;
    let header={
      'Accept':'text/csv'
    }
    try {
      setIsDownloading(true)
    let request_payload = {
      startDate: formatDateByTimezone(new Date(),true),
      endDate:  formatDateByTimezone(new Date(),true),
      listName: state.filterPrice
    }
    const res= await DOMAIN.post(`downloads/priceList`,request_payload,header);
    if(res.status==='scheduled'){
      setTimeout(() => {
        const dowId = DOMAIN.get(`downloads/status/${res.id}`);
        dowId.then((val) => {
          if (val.status === "completed") {
              DOMAIN.get(`downloads/analytics/${val.fileName}${val.fileExtension}`)
                  .then((ItemMasterDwnld) => {
                      const url = window.URL.createObjectURL(new Blob([ItemMasterDwnld]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', val.fileName + '.csv');
                      document.body.appendChild(link);
                      link.click();
                      setIsDownloading(false);
                  })
                  .catch((error) => {

                      console.error('Error downloading CSV:', error);
                      setIsDownloading(false);
                  });
          }
      });
        }, 8000);
    }
    }

        catch (error) {
          setState((_) => {
            return { ..._,message:{text:error?.data?.message},};
          })
          setTimeout(() => {
            setState((prevState) => ({
              ...prevState,
              message: null,
            }));
          }, 3500);
           setIsDownloading(false)
         }

  }

  const onDownloadSampleFile = () => {
    onDownloadXlsFile('samples/downloads/Price_List_Upload_Sample','Price_List_Upload_Sample')
  }

  const onUploadPriceList=()=>{
    setShowUpload(true)
  }

  const onUploadClose = () => {
    setShowUpload(false);
    setUploadedFile([]);
    setUploadFileStatusBlock("")
  }
  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        Boolean(state.isListReady) &&
        <>



          <DataGrid
            columnResize
            resetDataSource={state.resetDataSource}
            showDefaultFilters
            className='full-flex'
            columns={Columns}
            actionProperties={{pinned:'right',width:130,minWidth:120}}
            modalFormStatusObj={modalFormStatusObj}
            selectAll={selectAll}
            checkbox={checkbox}
            getRows={fetchProducts}
            {...buttonData}
            RightComponent={() => {
              return (<>
          <div className="flexRow justifyContentFlexStart alignItemsCenter margRight">
{         uploadpriceMaster?   <button title={t('pages.productsContent.manageProducts.uploadPriceList')} className='dropdownStyle1-TextMedium' onClick={() => onUploadPriceList(true)}> <span><img  className="icon-size-min" alt='uploadItem' src={uploadItemIcon} /></span></button>:<></>}
         { downloadpriceMaster?  <button className='dropdownStyle1-TextMedium' disabled={!state.filterPrice} onClick={onDownloadPriceList}>
         {isDownloading ? (<span title={t('filters.downloadingMaster')}><img  className='icon-size download-icon'  alt='downloadMaster' src={LoadingGIF} /> </span> ):
         (<span><img title={t('pages.productsContent.manageProducts.download')} className="icon-size-min" alt='downloadMaster' src={downloadMasterIcon} /></span>)}
         </button> :<></>}
          </div>

              <button className='flexRow justifyContentFlexEnd saleType-div margRight'>
              <CustomSelect
                options={priceListOptions?.current??[]}
                placeHolder="Search Price List"
                width={'16rem'}
                value={state.filterPriceValue}
                onChange={handleSelectPriceList}
              />
              </button>
              </>
              )
            }}
            actions={[
              { detail: [{ src: Edit2, value: "edit",title:'Edit' }] }
            ]}
            onAction={handleRowAction}
          />
          {
            state.showAddForm &&
            <AddProductModal
              title={t('pages.productsContent.manageProducts.addModalTitle')}
              onClose={handleModalClose}
              onSubmit={handleAddSectorSubmit}
              modalFormStatusObj={modalFormStatusObj}
              priceList={state.filterPrice}
              options={products}
              fields={Fields.current}
            />
          }
          {
            Boolean(state.editRow) && editpriceMaster &&
            <AddProductModal
              title={t('pages.productsContent.manageProducts.editItem')}
              onClose={handleModalClose}
              onSubmit={handleEditSectorSubmit}
              priceList={state.filterPrice}
              options={products}
              fields={state.editRow}
              modalFormStatusObj={modalFormStatusObj}
            />
          }
           {
            Boolean(state.deleteRows) &&
              <DeleteConf
                description={t('pages.productsContent.manageProducts.removeMsg')}
                onCloseDelete={handleModalClose}
                buttonStat={buttonStat}
                modalFormStatusObj={modalFormStatusObj}
                onContinue={handleDeleteConfirm}
              />
            }
           {
            showUpload &&
            <UploadModal
              modelTitle={t('pages.productsContent.manageProducts.uploadPriceList')}
              inputFields={"manage_products"}
              onUploadClose={onUploadClose}
              onDownloadSampleFile={onDownloadSampleFile}
              setFormDetails={setFormDetails}
              uploadedFile = { uploadedFile }
              onUploadFileChangeHandler = { (e) => onUploadFileChangeHandler(e) }
              uploadFileStatusBlock = { uploadFileStatusBlock }
              allowedExtensions={ MIMETypes.excel }
            />
          }
        </>
      }
       {!ready &&<div className='overlay_hide sub'></div>}
    </div>
  )
}
